import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
//import { NotificationService } from './notification.service';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoginUserDetailsModel } from '../model/FormsEntity/loginUserDetails.Model';
import { NotificationService } from '../core/core.module';
import { environment } from '../../environments/environment';



@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<LoginUserDetailsModel>;
  public currentUser: Observable<LoginUserDetailsModel>;

  private usersUrl: string;
  constructor(private httpClient: HttpClient,
    // private notification:NotificationService,
    private readonly notificationService: NotificationService,
    private router: Router) {
    this.usersUrl = environment.baseUrl;


    this.currentUserSubject = new BehaviorSubject<LoginUserDetailsModel>(JSON.parse(localStorage.getItem('currentUser')));

    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): LoginUserDetailsModel {

    return this.currentUserSubject.value;
  }
  

  authenticate(model) {

    return this.httpClient.post<any>(this.usersUrl + "login1", model).pipe(
      map(
        userData => {
          console.log(userData);

          if (userData && userData.error) {
            // this.notification.warn(userData.error.errorMessage);
            this.notificationService.error(userData.error.errorMessage);

          } 
          else if (userData.status.id == 1) {
            this.router.navigate(['/otp']);

          }
         
          else if (userData && userData.header.token) {
            sessionStorage.setItem('username', userData.username);
            let tokenStr = userData.header.token;
            sessionStorage.setItem('token', tokenStr);
            sessionStorage.setItem('currentUser', userData.data);
            localStorage.setItem('currentUser', JSON.stringify(userData.data));
            sessionStorage.setItem('menuUrl', JSON.stringify(userData.data.menuUrl));
            sessionStorage.setItem('currentDate', userData.data.currentDate);

            // this.notification.success(userData.status.detailMessage);

            this.notificationService.success(userData.status.detailMessage);
            this.router.navigate(['/home']);
            this.currentUserSubject.next(userData.data);
          } else

            return userData.data;
        }

      )

    );
  }

  validateOtp(model) {

    return this.httpClient.post<any>(this.usersUrl + "validateOtp", model).pipe(
      map(
        userData => {

          if (userData && userData.error) {
            // this.notification.warn(userData.error.errorMessage);
            this.notificationService.error(userData.error.errorMessage);

          } else if (userData.status.id == 11) {
            this.notificationService.error(userData.status.detailMessage);
            return;
          }

          else if (userData && userData.header.token) {
            sessionStorage.setItem('username', userData.username);
            let tokenStr = userData.header.token;
            sessionStorage.setItem('token', tokenStr);
            sessionStorage.setItem('currentUser', userData.data);
            localStorage.setItem('currentUser', JSON.stringify(userData.data));
            sessionStorage.setItem('menuUrl', JSON.stringify(userData.data.menuUrl));
            sessionStorage.setItem('currentDate', userData.data.currentDate);
            this.notificationService.success(userData.status.detailMessage);
            this.router.navigate(['/home']);
            this.currentUserSubject.next(userData.data);
          } else

            return userData.data;
        }

      )

    );
  }

  isUserLoggedIn() {
    let user = sessionStorage.getItem('username')
    // console.log(user)
    return !(user === null)

  }

  logOut() {
    sessionStorage.removeItem('mobileNo');
    sessionStorage.removeItem('passkey');
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('currentUser');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('menuUrl');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('appMenu');
    sessionStorage.removeItem('selectedLang');
  }
}